module.exports = __webpack_public_path__ + "img/nt50-00-80-1_4.prt.7c29ef9d.jpg";